"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHashValues = void 0;

var getHashValues = function getHashValues() {
  var hash = window.location.hash;

  if (hash.match(/^#/)) {
    return hash.substring(1).split('&').reduce(function (o, kv) {
      var a = kv.split('=');
      o[a[0]] = a[1];
      return o;
    }, {});
  } else {
    return {};
  }
};

exports.getHashValues = getHashValues;
//# sourceMappingURL=utils.js.map